// extracted by mini-css-extract-plugin
module.exports = {"primary":"#5576d1","green":"#28a745","red":"#dc3545"};